/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_MyAvailabilityWindow = {
    /**
     * End in HH:MM, local to the organisation; after start_time
     */
    end_time: string;
    /**
     * available: outside the available windows of the weekday the caller is unavailable. unavailable: the window itself is blocked.
     */
    kind: employee_selfservice_MyAvailabilityWindow.kind;
    /**
     * Start in HH:MM, local to the organisation
     */
    start_time: string;
    /**
     * ISO weekday, 1 = Monday ... 7 = Sunday
     */
    weekday: number;
};
export namespace employee_selfservice_MyAvailabilityWindow {
    /**
     * available: outside the available windows of the weekday the caller is unavailable. unavailable: the window itself is blocked.
     */
    export enum kind {
        AVAILABLE = 'available',
        UNAVAILABLE = 'unavailable',
    }
}

